import { Button, Modal } from "antd";
import React, { useState } from "react";
import { CalendarCell } from "../../../../../models/calender";
import {
  getFullCanChi,
  getVietnameseDayInfo,
} from "../../../../../utilities/genarateMonth";
import { useModalLockScroll } from "../../../../../hooks/useModalLockScroll";

interface ButtonShowCalendarProps {
  cell: CalendarCell;
  child: React.ReactNode;
}

const ButtonShowCalendar: React.FC<ButtonShowCalendarProps> = (
  props: ButtonShowCalendarProps
) => {
  const { child, cell } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const solarDay = getVietnameseDayInfo(cell?.date);
  const canchi = getFullCanChi(cell?.date);
  const lunaDay = canchi?.lunarRaw;
    useModalLockScroll(isModalOpen);
  return (
    <div className="w-full">
      <button className="w-full" onClick={showModal}>
        {child}
      </button>
      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        centered
        className="!p-0"
        styles={{
          content: {
            background: "rgba(0,0,0,0.85)",
            backdropFilter: "blur(10px)",
          },
        }}
      >
        <div className="w-full text-white p-2 iphone15promax:p-4 space-y-4">
          {/* Header */}
          <div className="text-center">
            <p className="text-3xl font-bold tracking-wide">
              {solarDay?.dayOfWeek}
            </p>
            <p className="text-gray-400 text-lg mt-1">
              Tháng {solarDay?.month}/{solarDay?.year}
            </p>
          </div>

          {/* Số ngày lớn */}
          <div className="flex justify-center">
            <div className="text-[120px] font-bold text-blue-600 leading-none">
              {solarDay?.day}
            </div>
          </div>

          {/* Card âm lịch */}
          <div className="bg-zinc-900/80 rounded-2xl p-4 border border-zinc-700">
            <p className="text-center text-lg font-semibold text-white mb-3 tracking-widest">
              ÂM LỊCH
            </p>

            <div className="flex justify-center gap-8 items-center">
              {/* Phần số âm */}
              <div className="text-center">
                <p className="text-[70px] font-bold text-red-500 leading-none">
                  {lunaDay?.day}
                </p>
                <p className="text-lg font-semibold text-red-400 mt-1">
                  Tháng {lunaDay?.month}
                </p>
              </div>

              {/* Phần Can Chi */}
              <div className="flex flex-col gap-2.5">
                {[
                  { label: "Ngày", value: canchi?.day },
                  { label: "Tháng", value: canchi?.month },
                  { label: "Năm", value: canchi?.year },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="px-4 py-1 rounded-full bg-emerald-500/20 whitespace-nowrap text-emerald-300 font-medium text-[15px] text-center"
                  >
                    {item.label} {item?.value}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Button đóng */}
          <div className="flex justify-center pt-2">
            <button
              onClick={handleCancel}
              className="px-8 py-2 rounded-full bg-white/10 hover:bg-white/20 transition text-white font-medium"
            >
              Đóng
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ButtonShowCalendar;
